import { getCurrentInstance } from 'vue';

export function useToast() {
  const currentInstance = getCurrentInstance();

  return currentInstance?.proxy.$toast;
}
